// (function(window, document) {
//     'use strict';
//
//     if(window.location.href.indexOf('#pagination-anchor') > -1) {
//         window.addEventListener('load', function () {
//             let paginationAnchorElement = document.querySelector('#pagination-anchor');
//
//             if(paginationAnchorElement !== null) {
//               paginationAnchorElement.scrollIntoView({behavior: 'instant', block: 'center', inline: 'nearest'});
//             }
//
//         });
//     }
// })(window, document);
